/**
 * @file currencies.api.js
 * @module CurrenciesAPI
 * @description HTTP API wrapper for currency lookup and conversion endpoints. Methods return Axios promises.
 */

import axios from "axios";
import { EXCHANGERATE_API_KEY, EXCHANGERATE_API_URL } from "../config/env";

export const CurrenciesAPI = {
    /**
     * Get conversion rate between two currencies using external exchangerate API.
     * @param {string} fromCurrencyCode - Source currency code (e.g., 'USD').
     * @param {string} toCurrencyCode - Target currency code (e.g., 'EUR').
     * @returns {Promise} Axios promise resolving to conversion data (rates and metadata).
     */
    conversionCurrency: (fromCurrencyCode, toCurrencyCode) => {
        return axios.get(`${EXCHANGERATE_API_URL}/${EXCHANGERATE_API_KEY}/pair/${fromCurrencyCode}/${toCurrencyCode}`)
    }
}